var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from 'react';
import Button from 'components/Button/Button';
import { getCookie } from 'app/helpers/userHelper';
import ExternalLink from 'components/Icons/ExternalLink';
import constants from 'app/constants/global-constants';
// import { launchSandboxWithCmd } from '../../helper';
var clientId = constants.GOOGLE_CLIENT_ID;
var developerKey = constants.GOOGLE_DEVELOPER_KEY;
// See "Project number" under "IAM & Admin" > "Settings"
var appId = constants.GOOGLE_APP_ID;
// Scope to use to access user's Drive items.
var scope = ['https://www.googleapis.com/auth/drive.readonly'];
var buttonObject = {
    0: {
        text: 'Pick A SpreadSheet',
        options: {
            color: 'yellow',
            className: 'font-regular',
            size: 'small',
        },
    },
    1: {
        text: 'Open Neo4j Browser',
        options: {
            color: 'green',
            size: 'small',
            className: 'font-regular launch-action-btn',
            primary: true,
            labeled: true,
            icon: React.createElement(ExternalLink, null),
        },
    },
};
var GoogleSheetUseCaseButton = /** @class */ (function (_super) {
    __extends(GoogleSheetUseCaseButton, _super);
    function GoogleSheetUseCaseButton(props) {
        var _this = _super.call(this, props) || this;
        _this.oauthToken = getCookie('com.neo4j.sandboxv3.gsheet.auth');
        // Check if the cookie exist and if the sandboxHashKey matches in cookie matches with runningSandboxes
        // let gsheetInCookie = getCookie('com.neo4j.sandboxv3.gsheet.selected');
        // if (gsheetInCookie) gsheetInCookie = JSON.parse(gsheetInCookie);
        // const selectedGsheet =
        // 	gsheetInCookie &&
        // 	gsheetInCookie.sandboxHashKey === props.data.sandboxHashKey
        // 		? gsheetInCookie
        // 		: null;
        // If sandboxHashKey mismatch, then remove the existing cookie
        // if (!selectedGsheet && gsheetInCookie) {
        // 	removeCookie('com.neo4j.sandboxv3.gsheet.selected');
        // 	removeCookie('com.neo4j.sandboxv3.gsheet.auth');
        // }
        _this.apiLoaded = {
            auth: false,
            picker: false,
        };
        return _this;
        // this.state = {
        // 	btnState: this.oauthToken && selectedGsheet ? 1 : 0, // 0 = need to do auth and select a sheet, 1 = sheet avaiable. Can Open Browser
        // 	selectedGsheet: selectedGsheet || null,
        // };
        // this.handleClick = this.handleClick.bind(this);
        // this.handleSheetPicker = this.handleSheetPicker.bind(this);
        // this.pickerCallback = this.pickerCallback.bind(this);
    }
    GoogleSheetUseCaseButton.prototype.componentDidMount = function () {
        console.group('Google Sheet');
        // window.gapi.load('client:auth2', () => {
        // 	this.apiLoaded.auth = true;
        // });
        // gapi.load('picker', () => {
        // 	this.apiLoaded.picker = true;
        // });
    };
    GoogleSheetUseCaseButton.prototype.createPicker = function () {
        console.log('create picker');
        if (this.apiLoaded.auth && this.oauthToken) {
            // const view = new google.picker.View(google.picker.ViewId.DOCS);
            // view.setMimeTypes('image/png,image/jpeg,image/jpg');
            // const picker = new google.picker.PickerBuilder()
            // 	.setAppId(appId)
            // 	.setOAuthToken(this.oauthToken)
            // 	.addView(google.picker.ViewId.SPREADSHEETS)
            // 	.setDeveloperKey(developerKey)
            // 	.setCallback(this.pickerCallback)
            // 	.build();
            // picker.setVisible(true);
        }
    };
    GoogleSheetUseCaseButton.prototype.pickerCallback = function (data) {
        // console.log('picker callback');
        // if (data.action === google.picker.Action.PICKED) {
        // 	const { data: sandbox } = this.props;
        // 	const selectedGsheet = data.docs[0];
        // 	selectedGsheet.sandboxHashKey = sandbox.sandboxHashKey;
        // 	setCookie('com.neo4j.sandboxv3.gsheet.selected', data.docs[0]);
        // 	this.setState({ selectedGsheet: data.docs[0], btnState: 1 });
        // }
    };
    GoogleSheetUseCaseButton.prototype.handleSheetPicker = function () {
        console.log('handle sheet picker');
        // window.gapi.auth.authorize(
        // {
        // 	client_id: clientId,
        // 	scope,
        // 	immediate: false,
        // },
        // (authResult) => {
        // 	console.log(authResult);
        // 	if (authResult && !authResult.error) {
        // 		this.oauthToken = authResult.access_token;
        // 		setCookie('com.neo4j.sandboxv3.gsheet.auth', authResult.access_token);
        // 		this.createPicker();
        // 	}
        // },
        // );
    };
    GoogleSheetUseCaseButton.prototype.handleClick = function () {
        var _a = this.state, btnState = _a.btnState, selectedGsheet = _a.selectedGsheet;
        var _b = this.props, sandbox = _b.data, accessToken = _b.accessToken;
        if (btnState === 1) {
            var gsheetUrl = "https://docs.google.com/spreadsheets/d/".concat(selectedGsheet.id, "/gviz/tq?tqx=out:csv%26sheet=Sheet1%26access_token=").concat(this.oauthToken);
            var gSheetGuideUrl = encodeURI("https://neo4jsandbox.com/guides/dyn/gsheets/index.html?csvUrl=".concat(gsheetUrl));
            // launchSandboxWithCmd(sandbox, accessToken, gSheetGuideUrl);
        }
        else {
            this.handleSheetPicker();
        }
    };
    GoogleSheetUseCaseButton.prototype.render = function () {
        var _a = this.state, btnState = _a.btnState, selectedGsheet = _a.selectedGsheet;
        return (React.createElement("div", null,
            React.createElement(Button, __assign({ onClick: this.handleClick }, buttonObject[btnState].options), buttonObject[btnState].text),
            selectedGsheet && (React.createElement("div", null,
                React.createElement("p", { className: "mt3 mb1 font-x-small" },
                    React.createElement("span", { className: "" }, "You selected:"),
                    ' ',
                    React.createElement("span", { className: "font-bold" }, selectedGsheet && selectedGsheet.name)),
                React.createElement("p", { className: "font-x-small text-underline" },
                    React.createElement("a", { onClick: this.handleSheetPicker }, "Pick a different sheet"))))));
    };
    return GoogleSheetUseCaseButton;
}(Component));
export default GoogleSheetUseCaseButton;
